export default __webpack_public_path__ + "static/media/fw-hailey-er-Yellow Gold.74644360.mp4";